<template>
  <div class="all">
    <div class="nav-pc">
      <div class="title">
        <img src="@/static/img/trip_edge_icon.svg" />
        行程管理
      </div>
    </div>
    <div class="center-pc">
        <ul class="type-nav">
            <li :class="navType=='pickUp'?'active':''" @click="changeType('pickUp')">接机</li>
            <span>|</span>
            <li :class="navType=='dropOff'?'active':''" @click="changeType('dropOff')">送机</li>
            <span>|</span>
            <li :class="navType=='hotel'?'active':''" @click="changeType('hotel')">酒店</li>
            <!-- <span>|</span>
            <li :class="navType=='car'?'active':''" @click="changeType('car')">用车需求</li> -->
        </ul>
        <div v-if="navType=='pickUp'">
            <div v-for="(item, index) in tripList" :key="index" class="list-item" :style="{'background-color': index%2 == 0 ? 'rgb(249 242 229)' : 'rgb(255 252 245)' }">
                <img class="item-l" src="@/static/img/xlx_icon.svg" />
                <div class="item-center">
                    <p>
                        <label class="label-item"><span>到达时间</span>{{ item.departureTime | timeFilter }}</label>
                        <label class="label-item"><span>联系人</span>{{ item.guestContactName }}</label>
                    </p>
                    <p>
                        <label class="label-item"><span>到达站点</span>{{ item.departurePlace }}</label>
                        <label class="label-item"><span>联系方式</span>{{ item.guestContactMobile }}</label>
                    </p>
                    <p>
                        <label class="label-item"><span>目的地</span>{{ item.arrivalDestination }}</label>
                    </p>
                </div>
                <div class="item-r">
                    <span @click="editTrip(item)">{{ item.mainStatus==1||item.auditStatus==1?'查看':'编辑' }}行程</span>
                    <span v-if="item.mainStatus!=-2" @click="cancelTrip(item)">取消</span>
                </div>
            </div>
        </div>
        <div v-if="navType=='dropOff'">
            <div v-for="(item, index) in tripList" :key="index" class="list-item" :style="{'background-color': index%2 == 0 ? 'rgb(249 242 229)' : 'rgb(255 252 245)' }">
                <img class="item-l" src="@/static/img/xlx_icon.svg" />
                <div class="item-center">
                    <p>
                        <label class="label-item"><span>离开时间</span>{{ item.arrivalTime | timeFilter }}</label>
                        <label class="label-item"><span>联系人</span>{{ item.guestContactName }}</label>
                    </p>
                    <p>
                        <label class="label-item"><span>出发地</span>{{ item.departurePlace }}</label>
                        <label class="label-item"><span>联系方式</span>{{ item.guestContactMobile }}</label>
                    </p>
                    <p>
                        <label class="label-item"><span>离时站点</span>{{ item.arrivalDestination }}</label>
                    </p>
                </div>
                <div class="item-r">
                    <span @click="editTrip(item)">{{ item.mainStatus==1||item.auditStatus==1?'查看':'编辑' }}行程</span>
                    <span v-if="item.mainStatus!=-2" @click="cancelTrip(item)">取消</span>
                </div>
            </div>
        </div>
        <div v-if="navType=='hotel'">
            <div v-for="(item, index) in tripList" :key="index" class="list-item" :style="{'background-color': index%2 == 0 ? 'rgb(249 242 229)' : 'rgb(255 252 245)' }">
                <img class="item-l" src="@/static/img/xlx_icon.svg" />
                <div class="item-center">
                    <p>
                        <label class="label-item"><span>入住时间</span>{{ item.checkinTime | timeFilter('{y}-{m}-{d}') }} -- {{ item.leaveTime | timeFilter('{y}-{m}-{d}') }}</label>
                        <label class="label-item"><span>房型</span>{{ item.roomTypeId | optionsFilter('roomOp') }}</label>
                    </p>
                    <p>
                        <label class="label-item"><span>酒店类型</span>{{ item.hotelLevel | optionsFilter('hotelOp') }}</label>
                        <label class="label-item"><span>数量</span>{{ item.roomCount }}间</label>
                    </p>
                </div>
                <div class="item-r">
                    <span @click="editTrip(item)">{{ item.mainStatus==1?'编辑':'查看' }}行程</span>
                    <span v-if="item.mainStatus!=0" @click="cancelTrip(item)">取消行程</span>
                </div>
            </div>
        </div>
        <div v-if="navType=='car'">
            <div v-for="(item, index) in tripList" :key="index" class="list-item" :style="{'background-color': index%2 == 0 ? 'rgb(249 242 229)' : 'rgb(255 252 245)' }">
                <img class="item-l" src="@/static/img/xlx_icon.svg" />
                <div class="item-center">
                    <p>
                        <label class="label-item"><span>离开时间</span>{{ item.arrivalTime | timeFilter }}</label>
                        <label class="label-item"><span>出发地点</span>{{ item.departurePlace }}</label>
                    </p>
                    <p>
                        <label class="label-item" style="width: 30%;"><span>车辆类型</span>{{ item.requireCarType | optionsFilter('carTypeOp') }}</label>
                        <label class="label-item" style="width: 15%;"><span>人数</span>{{ item.guestCount }}</label>
                        <label class="label-item" style="width: 25%;"><span>联系人</span>{{ item.guestContactName }}</label>
                        <label class="label-item" style="width: 30%;"><span>联系方式</span>{{ item.guestContactMobile }}</label>
                    </p>
                </div>
                <div class="item-r">
                    <span @click="editTrip(item)">编辑行程</span>
                    <span @click="cancelTrip(item)">取消</span>
                </div>
            </div>
        </div>
        <div v-if="tripList.length==0" class="text-center">暂无需求</div>
    </div>

    <div class="remind-text">*行程申报与修改提交时间段为：2021年10月1日--11月3日，每天8:00-21:00。</div>
    <el-pagination class="set-el-pager" layout="prev, pager, next" :total="total" :page-size="5" @current-change="handleCurrentChange"></el-pagination>

    <div class="foo">
        <div>
            <button class="leftBtn" @click="goBack">返回</button>
            <button class="rightBtn" @click="addTrip">添加行程</button>
        </div>
    </div>
  </div>
</template>

<script>
import { hotelDemand, carDemands } from "@/api/trip"
var that

export default {
    filters: {
        timeFilter: function(tsp, type) {
            try {
                if (!tsp || tsp.toString().length == 0) {
                return ''
                }

                return that.$parseTime(tsp, type)
            } catch (err) {
                return ''
            }
        },
        optionsFilter: function(val, objType) {
            let str
            for(let i=0; i<that[objType].length; i++) {
                if(val == that[objType][i].val) {
                    str = that[objType][i].label
                    break
                }
            }
            return str
        }
    },
    data() {
        return {
            navType: 'pickUp',
            tripList: [],
            total: 5,
            hotelOp: [{
                label: '舒适型',
                val: '1'
            }, {
                label: '高档型',
                val: '2'
            }, {
                label: '豪华型',
                val: '3'
            }],
            roomOp: [{
                label: '大床房',
                val: '1'
            }, {
                label: '双床房',
                val: '2'
            }, {
                label: '行政套房',
                val: '3'
            }],
            carTypeOp: [{
                label: '舒适轿车',
                val: '1'
            }, {
                label: '豪华轿车',
                val: '2'
            }, {
                label: '商务车（7座）',
                val: '3'
            }, {
                label: '小巴（15座）',
                val: '4'
            }, {
                label: '大巴（20座）',
                val: '5'
            }],
        };
    },
    beforeCreate() {
        that = this
    },
    created() {
        if(this.$route.query.type) {
            this.navType = this.$route.query.type
        }
        this.getList(1)
    },
    watch: {
        navType: function(newVal) {
            console.log(newVal)
            this.getList(1)
        }
    },
    methods: {
        async getList(pageNum) {
            let res
            let params = {
                mainId: this.$session.get("cmm").mainId,
                page: {
                    pageNum: pageNum,
                    pageSize: 5
                }
            }
            switch(this.navType) {
                case 'pickUp':
                    res = await carDemands.getList(Object.assign({
                        demandType: '1'
                    }, params))
                    break
                case 'dropOff':
                    res = await carDemands.getList(Object.assign({
                        demandType: '2'
                    }, params))
                    break
                case 'hotel':
                    res = await hotelDemand.getList(params)
                    break
                case 'car':
                    res = await carDemands.getList(Object.assign({
                        demandType: '3'
                    }, params))
                    break
            }
            try {
                if(res && res.code == 200) {
                    this.tripList = res.data.result
                    this.total = res.data.count
                } else {
                    this.tripList = this.$options.data().tripList
                    this.total = this.$options.data().total
                }
            } catch (error) {
                console.log(error)
            }
        },
        changeType(type) {
            this.navType = type
            this.$router.push({
                name: 'trip_manage',
                query: {
                    type: type
                }
            })
        },
        addTrip() {
            let isSubmit = this.tripList.some((item) => {return item.mainStatus != -2})
            if((this.navType=='pickUp' || this.navType=='dropOff') && this.tripList.length >0 && isSubmit) {
                this.$message.warning('已完成本届接机需求提交，无法重复提交，或取消后重新提交')
            } else {
                this.$router.push(`/trip/edit/${this.navType}?type=add`)
            }
        },
        editTrip(row) {
            switch(this.navType) {
                case 'pickUp':case 'dropOff':
                    this.$router.push(`/trip/edit/${this.navType}?type=${row.mainStatus==1 || row.auditStatus==1?'view':'edit'}&id=${row.id}`)
                    break
                case 'hotel':
                    this.$router.push(`/trip/edit/${this.navType}?type=${row.mainStatus==1?'edit':'view'}&id=${row.id}`)
                    break
                default:
                    this.$router.push(`/trip/edit/${this.navType}?type=edit&id=${row.id}`)
                    break
            }
        },
        cancelTrip(row) {
            this.$msgbox({
                title: "确认信息",
                message: "确认取消该条行程？",
                showClose: false,
                showCancelButton: true,
                cancelButtonClass: "cancel-btn-color",
                confirmButtonClass: "btn-color",
                callback: async(action, instance) => {
                    if (action == "confirm") {
                        let res
                        switch(this.navType) {
                            case 'hotel':
                                res = await hotelDemand.cancel(row.id)
                                break
                            default:
                                res = await carDemands.cancel(row.id)
                                break
                        }
                        try {
                            if(res && res.code == 200) {
                                this.$message.success("行程取消成功")
                                this.getList(1)
                            } else {
                                this.$message.error("行程取消失败，请重新提交")
                            }
                        } catch (error) {
                            console.log(error)
                        }
                    }
                }
            })
        },
        goBack() {
            this.$router.push('/')
        },
        handleCurrentChange(val) {
            this.getList(val)
        }
    }
};
</script>

<style src="../../../static/css/regist.css" scoped></style>
<style src="../../../static/css/infoCommon.css" scoped></style>

<style scoped>
.center-pc {
    font-size: 20px;
    color: #C1A17B;
}
.type-nav {
    height: 35px;
    line-height: 35px;
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
}
.type-nav li {
    width: 110px;
    margin: 0 20px;
    text-align: center;
    font-family: "sourcehans-CN";
    cursor: pointer;
}
.type-nav .active {
    color: #fff;
    background: #C1A17B;
}
.list-item {
    /* height: 140px; */
    padding: 20px 0;
    margin-top: 15px;
    display: flex;
    align-items: center;
}
.list-item .item-l {
    width: 50px;
    margin: 0 25px;
}
.list-item .item-center {
    width: 70%;
    font-size: 18px;
    line-height: 35px;
}
.list-item .item-center .label-item {
    width: 50%;
    display: inline-block;
}
.list-item .item-center .label-item  span {
    margin-right: 30px;
}
.list-item .item-r span {
    padding: 5px 15px;
    cursor: pointer;
}
.list-item .item-r .span-text {
    cursor: unset;
}
.list-item .item-r span:not(:last-child) {
    border-right: 2px solid #C1A17B;
}
.list-item span {
    font-family: "sourcehans-CN";
}
.remind-text {
    margin-bottom: 10px;
    text-align: center;
    color: #C1A17B;
}
</style>
